import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { IObservationDefinition, IStatisticsConfiguration } from "@comunicare/comunicare-interfaces";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { StatObservationService } from "src/app/providers/stat-observation.service";

/**
 * This component is in charge of loading the statistic configuration based on the loinc of the an Observation and of
 * creating the grid container on which the observation-stats components will be displayed.
 */
@Component({
  selector: "app-observation-stats-container",
  templateUrl: "./observation-stats-container.component.html",
  styleUrls: ["./observation-stats-container.component.scss"],
})
export class ObservationStatsContainerComponent implements OnChanges {
  @Input() obsDefinition: IObservationDefinition;
  @Input() patientId: string;
  @Input() fromDate: moment.Moment;
  @Input() toDate: moment.Moment;

  @Output() hasContentChange = new EventEmitter<boolean>();

  public config: IStatisticsConfiguration;
  private configSubscription: Subscription;
  public isLoading = true;

  constructor(private statObservationService: StatObservationService) {}

  ngOnChanges(): void {
    if (this.configSubscription) {
      this.configSubscription.unsubscribe();
    }

    this.configSubscription = this.statObservationService
      .list(this.patientId, this.obsDefinition.loinc, this.fromDate.format("YYYY-MM-DD"), this.toDate.format("YYYY-MM-DD"))
      .pipe(first())
      .subscribe((x) => {
        this.isLoading = false;
        this.config = x;

        const hasContent = !!x;

        this.hasContentChange.emit(hasContent);
      });
  }
}
